import {useParams, useSearchParams} from "react-router-dom";
import PLATFORMS from "../tools/defaults/Platforms";
import GlobalGate from "../components/gate/GlobalGate";
import {GateProvider} from "../tools/contexts/GateContext";
import BusinessLicenseInquiryGate from "../components/gate/BusinessLicenseInquiryGate";
import DivarInternalAuthGate from "../components/gate/DivarInternalAuthGate";
import DivarInternalCarGate from "../components/gate/DivarInternalCarGate";
import ForeignerAuthGate from "../components/gate/ForeignerAuthGate";
import AccessError from "../components/gate/AccessError";
import TosanGate from "../components/gate/tosan/TosanGate";
import DivarInternalEstateGate from "../components/gate/DivarInternalEstateGate";

const Gate = () => {
    const [searchParams]=useSearchParams();
    const {id, service} = useParams();
    const error=searchParams.get('error');
    if(error){
       return <AccessError/>
    }
    return <GateProvider>
                {PLATFORMS.DIVAR.ID === id && PLATFORMS.DIVAR.APPS.I_AUTH.ID === service && <GlobalGate  guideKey={PLATFORMS.DIVAR.APPS.I_AUTH.GUIDE_KEY} />}
                {PLATFORMS.DIVAR.ID === id && PLATFORMS.DIVAR.APPS.C_SERVICE.ID === service && <GlobalGate guideTheme="blue" guideKey={PLATFORMS.DIVAR.APPS.C_SERVICE.GUIDE_KEY}/>}
                {PLATFORMS.DIVAR.ID === id && PLATFORMS.DIVAR.APPS.FIN_CHECK.ID === service && <GlobalGate guideTheme="green" guideKey={PLATFORMS.DIVAR.APPS.FIN_CHECK.GUIDE_KEY}/>}
                {PLATFORMS.DIVAR.ID === id && PLATFORMS.DIVAR.APPS.BUSINESS_LICENSE_INQUIRY.ID === service && <BusinessLicenseInquiryGate />}
                {PLATFORMS.DIVAR.ID === id && PLATFORMS.DIVAR.APPS.POLICE_CLEARANCE.ID === service && <GlobalGate guideKey={PLATFORMS.DIVAR.APPS.POLICE_CLEARANCE.GUIDE_KEY}/>}
                {PLATFORMS.DIVAR.ID === id && PLATFORMS.DIVAR.APPS.ORIGINALITY_DEVICE.ID === service && <GlobalGate guideKey={PLATFORMS.DIVAR.APPS.ORIGINALITY_DEVICE.GUIDE_KEY}/>}
                {PLATFORMS.DIVAR.ID === id && PLATFORMS.DIVAR.APPS.ESTATE.ID === service && <GlobalGate guideKey={PLATFORMS.DIVAR.APPS.ESTATE.GUIDE_KEY}/>}
                {PLATFORMS.DIVAR.ID === id && PLATFORMS.DIVAR.APPS.COMPANY_APPROVAL.ID === service && <GlobalGate guideKey={PLATFORMS.DIVAR.APPS.COMPANY_APPROVAL.GUIDE_KEY}/>}
                {PLATFORMS.DIVAR.ID === id && PLATFORMS.DIVAR.APPS.TRANSACTIONAL_CREDIT.ID === service && <GlobalGate  guideKey={PLATFORMS.DIVAR.APPS.TRANSACTIONAL_CREDIT.GUIDE_KEY}/>}
                {PLATFORMS.DIVAR.ID === id && PLATFORMS.DIVAR.APPS.DIVAR_INTERNAL_AUTH.ID === service && <DivarInternalAuthGate/>}
                {PLATFORMS.DIVAR.ID === id && PLATFORMS.DIVAR.APPS.DIVAR_INTERNAL_CAR.ID === service && <DivarInternalCarGate/>}
                {PLATFORMS.DIVAR.ID === id && PLATFORMS.DIVAR.APPS.FOREIGNER_AUTH.ID === service && <ForeignerAuthGate/>}
                {PLATFORMS.DIVAR.ID === id && PLATFORMS.DIVAR.APPS.DIVAR_INTERNAL_ESTATE.ID === service && <DivarInternalEstateGate/>}

                 {/*tosan services*/}
                {PLATFORMS.TOSAN.ID===id &&PLATFORMS.TOSAN.APPS.BILLS.ID===service&& <TosanGate/>}

           </GateProvider>


}
export default Gate;